<template>
  <el-container class="myContainer" style="width: 100%;height: 100%">
    <el-main class="myContainer">
      <el-card class="box-card" style="height: 100%;">
        <div class="right-main">
          <div style="width: 1000px;padding: 0 0 20px 0">
            <div class="titleClass">
              <!-----------------章节目录------------------>
              <span style="font-size: 20px;">&nbsp;{{ currentContent.name }}</span>
            </div>
            <!-------------------------------------章节目录和介绍-------------------------------------------->
            <div style="padding: 5px 0 5px 0">
              <!-----------------章节介绍------------------>
              <span style="font-size: 15px">{{ currentContent.remark }}</span>
            </div>
            <!-------------------------------------------视频---------------------------------------------->
            <div class="myVideo">
              <video
                  id="myVideo"
                  :src="currentUrl"
                  :controls="controls"
                  oncontextmenu="return false"
                  style="width: 100%;height: 100%;object-fit:fill;" >
              </video>
            </div>
          </div>
        </div>
      </el-card>
    </el-main>
  </el-container>
</template>

<script>
import {Delete} from "@element-plus/icons-vue";

export default {
  name: "HelpVideo",
  components: {Delete},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  data() {
    return {
      showCatalog:true,
      currentPage: 1,
      pageSize: 5,
      currentNode: {},//当前鼠标所选择的节点
      nodeIndex:1,//当前选择节点的下标
      user_id: '',
      showExercisesDialog: false,
      isLike: false,
      likeCnt: 0,
      watchCnt: 0,
      commentCnt: 0,
      commentList: [],
      showCommentInput: false,
      comment: '',
      chapterList: [],
      currentContent: {},//当前章节
      beforeChapter: {},//前一章节
      exerciseData: {},
      resultList: [],//课后习题完成情况的集合

      isNotEnd: true,//是否看完视频,看完为false

      isPass: false,//是否合格

      viewDuration: 0,
      timer: {}, // 定时器
      pauseTimer: {},// 暂停定时器
      controls: true,//是否显示控件
      control: false,//控件控制
      videoData: {},//视频基础数据
      exercisesPage: 0,// 当前页
      currentUrl:''
    }
  },

  mounted() {
    this.getContent();
  },

  methods: {
    async getContent() {
      this.currentUrl = '';
      this.currentContent = this.parentData;
      let params = {fileId:this.parentData.file_id};
      this.currentUrl = await this.$http('helpService.getHelpFileUrl',params);
      console.log(this.currentUrl);

      this.playVideo();
      this.viewMonitor();
    },

    //视频播放
    playVideo() {
      let that = this;
      //视频
      let myVideo = document.getElementById("myVideo");
      this.myVideo = myVideo;
      myVideo['disablePictureInPicture'] = true; // disablePictureInPicture的属性改为true 禁用画中画
      // myVideo['controlsList'] = 'noplaybackrate  nodownload'; // 隐藏下载按钮 倍速按钮
      myVideo['controlsList'] = ' nodownload'; // 隐藏下载按钮 倍速按钮

      let time1;
      let t1 = 0;

      //观看时长
      function view() {
        t1 += 0.25;
        that.viewDuration = t1;
        console.log('view-' + t1);
      }

      // 禁止快进
  /*    let sym;
      setInterval(function () {
        let time = myVideo.currentTime
        if (time - sym > 1) {
          this.myVideo.pause();
          myVideo.currentTime = sym
        }
        sym = myVideo.currentTime
      }, 500);*/

      //视频的总长度
      myVideo.addEventListener('loadedmetadata', () => { //加载数据
        this.totalDuration = myVideo.duration;
        console.log(this.totalDuration);
      });

      //播放
      myVideo.addEventListener('play', () => { //播放
        console.log("开始播放");
        // this.viewMonitor();
      });
      //暂停
      myVideo.addEventListener('pause', () => { //暂停
        console.log("暂停");
        window.clearInterval(time1);
        countTime();
      });
      //结束
      myVideo.addEventListener('ended', async () => { //结束
        console.log("播放结束");
        window.clearInterval(time1);
        countTime();   //向后台发数据
        this.isNotEnd = false;
        let course_id = '';
        if (this.componentParam === 'my_course_study') {
          course_id = this.parentData.course_id
        }else {
          course_id = this.parentData.id
        }
        let params = {
          course_id: course_id,
          chapter_id: this.currentNode.id,
        }
        this.$message.success("视频已看完")
        t1 = 0;
      }, false)
      //被主动暂停或网络暂停缓冲后重新播放会触发该事件
      //开始播放视频时，设置一个定时器，每250毫秒调用一次aa(),观看时长加2.5秒，
      //定时器需要放在playing事件中，否则无法实现网络缓冲后继续计时的功能
      myVideo.addEventListener("playing", () => {
        console.log("播放中");
       /* time1 = setInterval(() => {
          view();
          // this.getrViewDuration(t1)
        }, 250)*/
      }, false)
      //当因网络原因导致暂停时会触发该事件
      myVideo.addEventListener("waiting", () => {
        console.log('加载');
        window.clearInterval(time1);
        countTime();   //向后台发数据
      }, false)

      //计算观看时长向后台发数据
      async function countTime() {
        console.log("viewDuration", that.viewDuration)
        // let params = {viewDuration: that.viewDuration}
        // await this.$http('', params)
      }

      //直接关闭页面，并向后台发送数据
      if (window.addEventListener) {
        window.addEventListener("beforeunload", countTime, false);
      } else {
        window.attachEvent("onbeforeunload", countTime);
      }
    },

    //监控禁止切屏
    viewMonitor() {
      document.body.onblur = () => {
        if (this.myVideo.currentTime < this.totalDuration) {
          this.myVideo.pause();
        }
      }
    },
  },

}
</script>

<style scoped>

/*右边最外div样式*/
.right-main{
  height: 100%;
  padding: 0 0 20px 0;
  display: flex;
  justify-content: center;
  /*align-items: center;*/
}

/*任务状态样式*/
.task-status{
  position: absolute;
  right: 5px;
  top: 3px;
  width: 20px;
  height: 20px
}
.task-status img{
  width: 100%;
  height: 100%;
}

/*目录样式*/
.menu-box {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;
  align-items: center;
  display: flex;
  padding: 0 0 0 10px;
  cursor: pointer;
}

/*鼠标选择的样式*/
.menu-box:hover {
  background-color: whitesmoke;
}

/*title样式*/
.titleClass{
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 0 5px 0;
  border-bottom: 1px solid #e0dddd;
}

/*点赞等一系列操作的样式*/
.clickOperation {
  display: flex;
  align-items: center;
  font-size: 22px;
  position: absolute;
  right: 0;
}

.clickOperation p{
  margin: 2px 5px 0 5px;
}

/*视频样式*/
.myVideo {
  padding:0;
  border: 1px solid lightgrey;
  height:600px;
}

/*评论区样式*/
.comment {
  background-color: #f3f0f0;
  margin-top: 5px;
  padding-bottom: 10px;
}

/*输入框样式*/
.input {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 0 5px 8px 5px;
}

.input .button {
  font-size: 15px;
  margin-left: 20px;
  --el-button-size: 50px;
  margin-top: 10px;
}

/*评论内容样式*/
.isDelete {
  margin: 0 0 4px 20px;
  font-size: 15px;
  border-bottom: 1px solid #e0dddd;
}

/*分页样式*/
.pagination{
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
  padding: 0 5px 5px 0;
}

.myContainer {
  padding: 5px;
}

:deep(.el-card is-always-shadow) {
  height: 800px;
}

:deep(.el-card__body) {
  height: 100%;
  overflow: auto;
  padding: 15px 10px;
}

:deep(.el-checkbox.el-checkbox--large) {
  width: 100%;
}

:deep(.el-radio.el-radio--large) {
  width: 100%;
}

.content .el-radio-group el-radio {
  margin-left: 10px;
}

/*试题样式*/
.operation {
  padding: 30px;
}

.content .topic {
  display: inline-flex;
  align-items: center;
}

.topic .orderNumber {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 30px;
  background-color: rgb(39, 118, 223);
  color: #fff;
  border-radius: 4px;
  margin-right: 4px;
  font-size: 35px;
}

.topic .question_typeSingle {
  padding: 0 5px 0 5px;
  color: #409eff;
  background-color: #d9ecff;
  font-size: 22px;
}

.topic .question_typeFill {
  padding: 0 5px 0 5px;
  color: #e6a23c;
  background-color: #faecd8;
  font-size: 22px;
}

.topic .question_typeJudge {
  padding: 0 5px 0 5px;
  color: #67c23a;
  background-color: #f0f9eb;
  font-size: 22px;
}

.choice {
  margin-left: 30px;
}

.tip span {
  margin: 5px;
  font-size: 20px;
  text-align: left;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.right .title p {
  display: flex;
  margin-top: 0;
  background-color: #fff;
  height: 50px;
  line-height: 50px;
  margin-left: 10px;
  font-size: 20px;
}

.right .title span {
  font-size: 20px;
}

.select el-select {
  color: #0a84ff;
}

.bottom {
  padding: 30px;
  margin: 20px 100px 20px 100px;
  font-size: 20px;
  border: 1px solid lightgrey;
}

.answer .top .index li {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.right .topic li {
  display: flex;
  align-items: center;
  padding: 0 0 0 5px;
}

/*点赞样式*/
.circle {
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 0 0 rgba(223, 46, 58, 0.5);
}

.circle .img-box {
  width: 24px;
  height: 24px;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  /*-khtml-user-select: none;*/
  user-select: none;
  /*// 防止快速点击图片被选中，可不加，为提高体验，博主加上了这几行代码。*/
}

.circle .img-box img {
  width: 100%;
  height: 100%;
}

.check {
  -webkit-transition: box-shadow 0.5s;
  -moz-transition: box-shadow 0.5s;
  -o-transition: box-shadow 0.5s;
  transition: box-shadow 0.5s;
  box-shadow: 0 0 0 1em rgba(226, 32, 44, 0);
}

.img-box-check {
  animation: anm 0.5s;
  -moz-animation: anm 0.5s;
  -webkit-animation: anm 0.5s;
  -o-animation: anm 0.5s;
}

@keyframes anm {
  0% {
    transform: scale(0);
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
  }
  50% {
    transform: scale(1.3);
    -webkit-transform: scale(1.3);
    -moz-transform: scale(1.3);
  }
  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
  }
}



</style>